<template>
    <div class="purchase-outfit-item">
        <div class="wtw-container small" @click.stop="toggleProduct">
        <div class="purchase-outfit-item-info-container"
                :class="{ selected: product.selected }">
            <div class="purchase-outfit-item-image"
                    :style="{ backgroundImage: 'url(' + product.product_image_url + ')' }">
            </div>
            <div class="purchase-outfit-item-info">
                <div v-if="product.product_brand_title" class="brand">
                    {{ product.product_brand_title }}
                </div>
                <div class="title">
                    {{ product.product_title }}
                </div>
                <div class="price">
                    {{ product.product_price | currency }}
                </div>
            </div>
        </div>
        <div class="purchase-outfit-item-check">
            <img v-show="product.selected"
                    :src="imageUrl('item-check.png')"
            />
            <img v-show="!product.selected"
                    :src="imageUrl('item-check-empty.png')"/>
        </div>
        </div>
        <div class="wtw-container small purchase-outfit-item-select-container">
            <div class="select-fix small purchase-outfit-size"
                    :class="{ selected: product.selected, disabled: !product.product_colors || !product.product_colors.length > 0 }"
                    v-if="product.product_colors && product.product_colors.length > 1">
                <select class="small" :value="product.product_option_value_id_color"
                        @change="event => optionChanged('color', event)">
                    <option :value="null">Color</option>
                    <option v-for="color in product.product_colors"
                            :value="color.product_option_value_id"
                            :key="color.product_option_value_id">
                        {{ color.product_option_value_title }}
                    </option>
                </select>
            </div>
            <select-validation v-show="product.warnAbout && product.warnAbout['color'] && product.selected" message="Select a color"></select-validation>
            <div class="select-fix small purchase-outfit-size"
                :class="{
                    selected: product.selected,
                    disabled: !product.product_sizes || !product.product_sizes.length > 0,
                    'oos-size': isSizeOOS
                }"
                v-if="!defaultSizeSelected && getSortedSizes.length > 0">
                <select class="small" :value="product.product_option_value_id_size"
                        @change="event => optionChanged('size', event)"
                        :disabled="!product.product_sizes || !product.product_sizes.length > 0">
                    <option :value="null">Size</option>
                    <option v-for="size in getSortedSizes"
                            :value="size.product_option_value_id"
                            :key="size.product_option_value_id">
                        <span>{{ size.product_option_value_title }}</span>
                    </option>
                </select>
                <span 
                    v-show="isSizeOOS"
                    class="oos-size-message">
                    Out of Stock - Please choose another size
                </span>
            </div>
            <select-validation v-show="product.warnAbout && product.warnAbout['size'] && product.selected" message="Select a size"></select-validation>
            <div v-if="isSizeOOS && product.selected" class="oos-buttons-container">
                <a class="button pink swap-button"
                    @click.stop="swapProduct(product)">
                    <span class="icon">
                        <img class="swap" :src="imageUrl('swap-white.svg')" />
                    </span>
                    SWAP
                </a>
                <button class="button oos-button" :disabled="true" v-if="defaultSizeSelected || getSortedSizes.length === 0">
                    OUT OF STOCK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixins from "../../mixins/mixins.js";
    import ProductMixins from "../../mixins/product-mixins.js";
    import SelectSizeValidation from '../cart/select-size-validation.vue';
    import PurchaseOutfitItem from './purchase-outfit-item.vue';

    export default {
        mixins: [Mixins, ProductMixins],
        props: ['product', 'toggleProduct', 'optionChanged', 'swapProduct'],
        data() {
            return {
                selectSizeIsOpened: false,
            };
        },
        components: {
            'select-validation': SelectSizeValidation,
        },
        computed: {
            getSortedSizes() {
                return this.sortSizes(this.getColorSizes(this.product))
            },
            isSizeOOS() {
                return this.sizeSelected && this.sizeSelected.in_stock == 0 || this.getSortedSizes?.length === 0;
            },
            sizeSelected() {
                return this.getSortedSizes.find(size => size.product_option_value_id === this.product.product_option_value_id_size);
            },
            defaultSizeSelected() {
                return this.sizeSelected && this.sizeSelected.is_default_value == 1;
            },
        },
        methods: {
        }
    };
</script>

<style lang="scss" scoped>
    .oos-button {
        background-color: #95989A;
        color: white;
        width: auto;    
        height: 30px;
        padding: 5px 12px;
        font-size: 15px;
    }
</style>